// useTableColumnsEquiposSinMovimiento.tsx

import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { EquiposSinMovimiento } from "../types/equipos-sin-movimiento.interface";

export function useTableColumnsEquiposSinMovimiento() {

  const columns = useMemo<MRT_ColumnDef<EquiposSinMovimiento>[]>(
    () => [
      {
        accessorKey: "fecha_registra",
        header: "Fecha Ultimo Movimiento",
      },
      {
        accessorKey: "meses_sin_movimiento",
        header: "Meses Sin Movimiento",
      },
      {
        accessorKey: "id_modelo",
        header: "ID Modelo",
      },
      {
        accessorKey: "codigo_producto",
        header: "Codigo Producto",
      },
      {
        accessorKey: "mod_nombre",
        header: "Modelo",
      },
      {
        accessorKey: "cantidad",
        header: "Cantidad",
      },
      {
        accessorKey: "tipo_transaccion",
        header: "Tipo Transaccion",
      },
      {
        accessorKey: "bodega_desde",
        header: "Bodega Desde",
      },
      {
        accessorKey: "bodega_hasta",
        header: "Bodega Hasta",
      },
      {
        accessorKey: "detalle_transferencia",
        header: "Detalle Transferencia",
      },
    ],
    []
  );

  return {
    columns
  };
}
